<template lang="html">
  <component :is="tag" class="text__main" :class="{ bold: bold, adaptive: adaptive }">
    <!-- @slot Безымянный слот. Используется для вставки текста-->
    <slot/>
  </component>
</template>

<script>
export default {
  name: 'bimTextMain',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__main {
  font-size: 18px;
  font-weight: normal;
  line-height: 1.44;
  letter-spacing: normal;
}

.text__main.bold {
  font-weight: bold;
}

@media all and (max-width: $phone-width) {
  .text__main.adaptive {
    font-size: 16px;
    line-height: 1.33;
  }
}
</style>
